// extracted by mini-css-extract-plugin
export default {"phoneValue":"phone-cell_phoneValue__YD3Nl","mutedValue":"phone-cell_mutedValue__+nPHy"};